const type = 'SET_LIMIT_PROPOSAL_NEXT_LIMIT_SLIDER';

const setLimitProposalNextLimitSlider = (data = {}) => ({
  data,
  type,
});

export { type };
export default setLimitProposalNextLimitSlider;
